import * as React from 'react';

const FileNotFound = (props) => {
    var preloader = document.getElementById("preloader");
    preloader.classList.add("hidden");
    const RedirectToHome = () => {
        props.history.push('/home');
    };
    return (
        <div>

            <div className='FilenotFoundbBG'>
                <div className='PageNotFound'>404!</div>
                <div className='PageNotFoundText'>Sorry, page not found</div>

                <div className='PageNotFoundBtn'> <button type="button" className='btn btn btn-primary' onClick={RedirectToHome}>Home</button></div>
            </div>
            
        </div>
    );
};

export default FileNotFound;
